// import iNoBounce from 'inobounce';
const var_name = 'overflow_hidden_modules';
const scroll_position_var_name = 'overflow_hidden_scroll_position';
const scroll_lock_attr_name = 'data-gld-scroll-lock';
const scroll_lock_attr_value = 'active';
class General {
  static setDocumentScrollLock(active = false) {
    if (active) {
      document.documentElement.setAttribute(
        scroll_lock_attr_name,
        scroll_lock_attr_value
      );
    } else {
      document.documentElement.removeAttribute(scroll_lock_attr_name);
    }
  }

  static isDocumentScrollLocked() {
    return (
      document.documentElement.getAttribute(scroll_lock_attr_name) ===
      scroll_lock_attr_value
    );
  }

  static init() {
    sessionStorage.removeItem(var_name);
    sessionStorage.removeItem(scroll_position_var_name);
    window.eventBodyOverflowHiddenController = new Event(
      'bodyOverflowHiddenController'
    );
  }

  static getScrollPosition() {
    return (
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      0
    );
  }

  static lockBodyScroll($_body) {
    if (sessionStorage.getItem(scroll_position_var_name) !== null) {
      return;
    }

    const scrollPosition = General.getScrollPosition();

    sessionStorage.setItem(scroll_position_var_name, scrollPosition);

    $_body.style.top = `-${scrollPosition}px`;
  }

  static unlockBodyScroll($_body) {
    const scrollPosition = parseInt(
      sessionStorage.getItem(scroll_position_var_name),
      10
    );

    $_body.style.top = '';
    sessionStorage.removeItem(scroll_position_var_name);

    if (!Number.isNaN(scrollPosition)) {
      window.scrollTo(0, scrollPosition);
    }
  }

  static bodyOverflowHiddenController(
    module_name = false,
    add = false,
    event = true
  ) {
    if (module_name) {
      const class_name = 'overflow-hidden';
      const $_body = document.querySelector('body');
      let modules = JSON.parse(sessionStorage.getItem(var_name)) || [];
      // let modules = [];

      if (add && !modules.includes(module_name)) {
        modules.push(module_name);
      } else {
        modules = modules.filter((item) => item !== module_name);
      }

      if (modules.length && !$_body.classList.contains(class_name)) {
        General.lockBodyScroll($_body);
        General.setDocumentScrollLock(true);
        $_body.classList.add(class_name);
      } else if (!modules.length) {
        $_body.classList.remove(class_name);
        General.setDocumentScrollLock(false);
        General.unlockBodyScroll($_body);
      }
      sessionStorage.setItem(var_name, JSON.stringify(modules));
      if (event) {
        document.dispatchEvent(window.eventBodyOverflowHiddenController);
      }
    } else {
      sessionStorage.removeItem(var_name);
    }
  }

  static randHex(len) {
    var maxlen = 32,
      min = Math.pow(16, Math.min(len, maxlen) - 1),
      max = Math.pow(16, Math.min(len, maxlen)) - 1,
      n = Math.floor(Math.random() * (max - min + 1)) + min,
      r = n.toString(16);
    while (r.length < len) {
      r = r + General.randHex(len - maxlen);
    }
    return r;
  }

  static toggleViewPort = (blockScale = true) => {
    let viewportContent = document.querySelector('meta[name=viewport]').content;
    if (blockScale) {
      viewportContent = `${viewportContent},user-scalable=0`;
    } else {
      viewportContent = viewportContent.replace(',user-scalable=0', '');
    }
    document
      .querySelector('meta[name=viewport]')
      .setAttribute('content', viewportContent);
  };

  static toggleDocumentLock = (
    module_name = false,
    add = false,
    event = true
  ) => {
    const toogleClassDocument = (modules = false) => {
      if (
        ((modules && modules.length) || modules === false) &&
        !General.isDocumentScrollLocked()
      ) {
        General.setDocumentScrollLock(true);
        // iNoBounce.disable();
      } else if (
        ((modules && !modules.length) || modules === false) &&
        General.isDocumentScrollLocked()
      ) {
        General.setDocumentScrollLock(false);
      }
    };

    if (module_name) {
      const var_name = 'document-lock';
      let modules = JSON.parse(sessionStorage.getItem(var_name)) || [];
      // let modules = [];

      if (add && !modules.includes(module_name)) {
        modules.push(module_name);
      } else {
        modules = modules.filter((item) => item !== module_name);
      }

      toogleClassDocument(modules);

      sessionStorage.setItem(var_name, JSON.stringify(modules));
      // if (event) {
      //     document.dispatchEvent(window.eventBodyOverflowHiddenController);
      // }
    } else {
      toogleClassDocument();
      // sessionStorage.removeItem(var_name);
    }
  };

  static debounce = (fn, wait) => {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  };

  static getMobileOS = () => {
    const ua = navigator.userAgent;
    if (/android/i.test(ua)) {
      return 'Android';
    } else if (
      /iPad|iPhone|iPod/.test(ua) ||
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
    ) {
      return 'iOS';
    }
    return 'Other';
  };
}
export default General;
